import { render, staticRenderFns } from "./ObjectPreview.vue?vue&type=template&id=4bbb6881&scoped=true"
import script from "./ObjectPreview.vue?vue&type=script&lang=ts"
export * from "./ObjectPreview.vue?vue&type=script&lang=ts"
import style0 from "./ObjectPreview.vue?vue&type=style&index=0&id=4bbb6881&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb6881",
  null
  
)

export default component.exports